import React from 'react';
import styled from 'styled-components';

export const CardWrapper = ({ children }) => {
  return <Card>{children}</Card>;
};

const Card = styled.div`
  &:not(:last-child) {
    margin-bottom: 30px;
  }

  font-family: sans-serif;
  background-color: var(--theme-primary-color);
  max-width: 100%;
  padding: 20px;
  border-radius: 24px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
`;
